var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.706 27.633c3.729 13.41-.574 27.321-12.55 37.648-11.975 10.397-31.624 17.21-44.89 9.035C3 66.213-3.884 42.979 2.283 26.199 8.45 9.347 27.668-1.123 43.013.096c15.419 1.22 27.036 14.199 30.693 27.537z",
    fill: "#011E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai_market_svg__clip0_3344_3028)",
    fill: "#B8EF36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.38 28.774h5.006v28.882h-5.007v-4.97c-2.491 3.813-6.124 5.723-10.88 5.723-4.028 0-7.469-1.477-10.31-4.421-2.84-2.944-4.261-6.536-4.261-10.77 0-4.235 1.42-7.827 4.261-10.776 2.841-2.944 6.282-4.422 10.31-4.422 4.756 0 8.389 1.91 10.88 5.724v-4.97zM33.133 53.562c2.916 0 5.355-.993 7.311-2.98 1.956-1.985 2.934-4.438 2.934-7.364s-.978-5.385-2.934-7.365c-1.956-1.986-4.4-2.979-7.311-2.979-2.911 0-5.298.993-7.254 2.979-1.956 1.986-2.94 4.444-2.94 7.365 0 2.92.978 5.385 2.94 7.365 1.956 1.986 4.378 2.979 7.254 2.979zM53.724 26.227c-.96 0-1.764-.327-2.416-.98-.657-.655-.978-1.444-.978-2.366 0-.923.326-1.723.978-2.4.652-.673 1.456-1.011 2.416-1.011s1.706.338 2.358 1.01c.658.678.978 1.472.978 2.4a3.22 3.22 0 01-.978 2.366c-.652.66-1.438.981-2.358.981zM56.198 28.773h-5.006v28.882h5.006V28.773z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai_market_svg__clip0_3344_3028"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17.928 19.47)",
    d: "M0 0h39.132v38.939H0z"
  })))));
}
export default SvgAiMarket;